import React from 'react';
import TextArea from '../../forms/TextArea';
import FormSetting from '../../layout/FormSetting';
import { QuestRoute } from '../../api/QuestRoutes';
import PageBreak from '../../layout/PageBreak';
import HamQuest from '../../api/HamQuestGiver';
import { generateId } from '../../utility/functions';
import GetState from '../../GetState';
import Form from '../../forms/Form';
import Input from '../../forms/Input';
import Checkbox from '../../forms/Checkbox';
import Button from '../../forms/Button';
import LoadingEllipsis from '../../forms/LoadingEllipsis';
import Col from '../../layout/Col';
import { IsAuthorized, userRoles } from '../../RoleProtected';
import Row from '../../layout/Row';
import Preput from '../../forms/Preput';
import ModalFactory from '../../Modal';

const Messaging = ({ children, ...props }) => {

    const isAuthorized = IsAuthorized(userRoles.editProducts);

    const Messages = () => {
        const [messages, fetchMessages] = GetState(QuestRoute.washClubs.messages, { loading: [] })
        const [assignments, fetchAssignments] = GetState(QuestRoute.washClubs.messageAssignments, { loading: [] })

        const updateAssignment = (id, type) => {
            HamQuest.put(`${QuestRoute.washClubs.messageAssignments}/${type}`, {
                messageId: id
            })
                .catch(ModalFactory.catch)
                .finally(() => fetchAssignments())
        }

        const addNewMessage = () => {
            const id = generateId();
            ModalFactory.show({
                id,
                title: 'Add New Message',
                body: (
                    <Form
                        inputs={{
                            message: '',
                            messageName: ''
                        }}
                        onSubmit={e => HamQuest.post(QuestRoute.washClubs.messages, e)
                            .then(() => {
                                ModalFactory.close(id);
                                fetchMessages();
                            })}
                    >
                        <Input
                            name='messageName'
                            label='Name'
                            required
                        />
                        <Preput
                            label='Message'
                            name='message'
                            tags={['FirstName', 'LastName', 'FullName', 'PassName']}
                            required
                        />
                    </Form>
                )
            })
        }

        return (
            <PageBreak>
                <Button roles={userRoles.editProducts} onClick={addNewMessage} key={generateId()}>Add New Message</Button>
                <PageBreak>
                    {messages.length ? messages.map((e, i) => (
                        <Col
                            key={`Messaging-${i}`}
                        >
                            <Row wrap>
                                <Checkbox
                                    label='Use on Kiosk Display'
                                    checked={assignments.displayMessageId === e.messageId}
                                    onChange={(f) => {
                                        if (!isAuthorized || assignments.displayMessageId === e.messageId) return;
                                        f.preventDefault();
                                        const id = assignments.displayMessageId === e.messageId ? null : e.messageId;
                                        updateAssignment(id, 'kiosk');
                                    }}
                                    readOnly
                                    standalone
                                    disabled={!isAuthorized}
                                />
                                <Checkbox
                                    label='Use on Receipt Footer'
                                    checked={assignments.receiptMessageId === e.messageId}
                                    onChange={(f) => {
                                        if (!isAuthorized || assignments.receiptMessageId === e.messageId) return;
                                        f.preventDefault();
                                        const id = assignments.receiptMessageId === e.messageId ? null : e.messageId;
                                        updateAssignment(id, 'receipt');
                                    }}
                                    standalone
                                    disabled={!isAuthorized}
                                />
                            </Row>
                            <Form
                                inputs={{
                                    message: e.message,
                                    messageName: e.messageName
                                }}
                                onSubmit={(f) => HamQuest.put(QuestRoute.washClubs.message(e.messageId), f)
                                    .then(() => fetchMessages())}
                                editable
                                roles={userRoles.editProducts}

                                formControls={[
                                    <Button
                                        label='Delete Message'
                                        key='deleteMsgBtn'
                                        roles={userRoles.editProducts}
                                        onClick={() => ModalFactory.confirmAndProcess({
                                            confirmation: {
                                                title: 'Are you sure?',
                                                body: 'Are you sure you want to delete this message?',
                                                type: 'warning',
                                            },
                                            promise: {
                                                title: 'Removing Message',
                                                callback: () => HamQuest.delete(QuestRoute.washClubs.message(e.messageId)).then(() => fetchMessages())
                                            },
                                            confirmed: {
                                                title: 'Message Deleted',
                                                type: 'success',
                                            }
                                        })}
                                    />
                                ]}
                            >
                                <Input
                                    name='messageName'
                                    label='Name'
                                    required
                                />
                                <Preput
                                    label='Message'
                                    name='message'
                                    tags={['FirstName', 'LastName', 'FullName', 'PassName']}
                                    required
                                />
                            </Form>
                        </Col>
                    )) : <div>Loading Messages<LoadingEllipsis /></div>}
                </PageBreak>
            </PageBreak>
        )
    }

    return (
        <PageBreak>
            <FormSetting
                label='Messages'
                info='Add personalized messages on the pay station display and receipt (not available for Gold Line pay stations).'
                text='Update'
                wrapper
                roles={userRoles.editProducts}
            >
                <Messages />
            </FormSetting>
        </PageBreak>
    );
}

export default Messaging;
